import React from 'react';
import Chart from 'react-apexcharts';
import { colors } from '@src/css_config/colorConstants.js';

const CardSkeleton = () => {
  const failureReasonsChartOpt = {
    series: [0],
    options: {
      chart: {
        type: 'radialBar',
      },
      colors: [
        function () {
          return colors.rs_failed;
        },
      ],
      plotOptions: {
        radialBar: {
          track: {
            background: colors.bg_failureReasonTrack,
          },
          hollow: {
            size: '60%',
          },

          dataLabels: {
            showOn: 'always',
            value: {
              color: colors.black,
              fontSize: '12px',
              show: true,
              offsetY: -10,
            },
          },
        },
      },

      stroke: {
        lineCap: 'round',
        colors: [colors.rs_failed],
        curve: 'smooth',
      },
      labels: [''],
    },
  };
  return (
    <div className="fontPoppinsSemiboldMd cursor-not-allowed overflow-hidden failerReason_card">
      <div className="fontPoppinsSemiboldXs failureReaon_CardHeader ">...</div>
      <div className="flex failureReasonsChartBlock items-center justify-evenly">
        <div className="tagChartCircle">
          <Chart options={failureReasonsChartOpt.options} series={failureReasonsChartOpt?.series} type="radialBar" />
        </div>
        <div className="tagFailedCount">
          <p className="fontPoppinsRegularXs8px text-black">Total steps tagged : 0</p>
          <p className="fontPoppinsRegularXs8px text-black">Total steps with this tag : 0</p>
        </div>
      </div>
    </div>
  );
};

export default CardSkeleton;
